import React from 'react';
import { Button } from 'design-system';
import { FormattedMessage } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import styles from './CreateMembership.module.css';

const BottomMessage = ({ url, messageKey, textKey }) => {
  const navigate = useNavigate();

  return (
    <div className={styles.footer}>
      <FormattedMessage id={textKey} />
      <Button
        variant="link"
        color="brand"
        className={styles.footerButton}
        onClick={() => navigate(url)}
        htmlType="button"
      >
        <FormattedMessage id={messageKey} />
      </Button>
    </div>
  );
};

export default BottomMessage;
